import {GenericService, ResultType} from '@/shared/xhttp';
import {Achat, Vente} from '@/models';
import {DateHelper} from "@/shared/utils";

export class VenteService extends GenericService<Vente> {

	public putMarkPaid(vente: Vente) {
		this.put(`/${vente.id}/mark-paid`);
	}

	public getTotauxVentes(totalParClient: boolean, totalParBoisType: boolean, totalParLongueur: boolean, totalDateDebut: string, totalDateFin: string): Promise<ResultType<Vente>> {
		return super.getC(`/totaux-ventes/${totalParClient ? 1 : 0 }/${totalParBoisType ? 1 : 0 }/${totalParLongueur ? 1 : 0 }/${totalDateDebut}/${totalDateFin}`, 10000);
	}
}